import { render } from "./DeclencheurSitePassTime.vue?vue&type=template&id=71852420"
import script from "./DeclencheurSitePassTime.vue?vue&type=script&lang=ts"
export * from "./DeclencheurSitePassTime.vue?vue&type=script&lang=ts"
script.render = render

export default script